import { ICompileService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  vsProviderName as RecordGridViewServiceProviderName,
  RecordGridViewServiceProvider,
} from "../../../records/views/recordGridView";
import { getBaseProgressiveDefinitionGrid } from "./progressiveDefinition";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../records/grids/cells/valueGetters";

export const vsObjectName = "progressiveDefinitionGame";

const url = "/api/machines/progressives/ProgressiveDefinitionGame";

ProgressiveDefinitionGame.$inject = [RecordGridViewServiceProviderName];
export function ProgressiveDefinitionGame(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ColumnDefinitionServiceName,
    ServerUtilityName,
    GridSettingsServiceName,
    "$compile",
    (
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      $compile: ICompileService
    ) => {
      const gridSettings = gridSettingsService.getGridSettings(
        Symbol("main.machines.progressives.games.grid")
      );
      const gridConfiguration = getBaseProgressiveDefinitionGrid(
        columnDefinitionService,
        serverUtility,
        gridSettings,
        $compile,
        url
      );

      gridConfiguration.defaultSort =
        "GameProgramNumber,ProgressiveDefinitionName,Order";

      gridConfiguration.columns = [
        ...(gridConfiguration.columns ?? []),
        columnDefinitionService.getStringColDef({
          field: "PaytableId",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineDenominationName",
          header: "Denomination",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MachineDenominationValue",
          header: "Denomination Value",
          hide: true,
        }),
        columnDefinitionService.getNumberColDef({
          field: "MaxCreditBet",
        }),
        columnDefinitionService.getNumberColDef({
          field: "TotalProgressiveResetAmount",
          valueGetter: moneyValueGetterFactory(),
          hide: true,
        }),
        columnDefinitionService.getNumberColDef({
          field: "TotalProgressiveContribution",
          valueGetter: percentageValueGetterFactory(),
          hide: true,
        }),
        columnDefinitionService.getNumberColDef({
          field: "TotalHiddenProgressiveContribution",
          valueGetter: percentageValueGetterFactory(),
          hide: true,
        }),
      ];

      return gridConfiguration;
    },
  ]);
}
